module.exports = __webpack_public_path__ + "img/19_fineStaff_lxm.4d52d1a5.png";